
export const CV_INFORMATION_CATEGORIES_COUNT = 7;
